import { Flex } from '@theme-ui/components';
import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

export const SummaryContainer = styled.div`
  background: ${theme.colors.whiteSecondary};
  padding: ${rem(10)} ${rem(20)};
`;

export const SummaryItem = styled(Flex)`
  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

/*
At time of writing there is no reliable differentiating value for status on an order item since they come in translated, which means we need to forgo customisations based on status
*/
export const StatusLabel = styled.span`
  /* background: ${theme.colors.darkGray}; */
  /* padding: 4px 8px; */
  /* color: #fff; */
  /* font-size: 14px; */
  /* border-radius: 5px; */
  font-weight: 600;
`;
